/**
 * Database driver mappings shared across the application
 * Used by Database connector and External Tables features
 */

export const driverClassMapping = {
    BigQuery: 'net.starschema.clouddb.jdbc.BQDriver',
    ClickHouse: 'com.clickhouse.jdbc.ClickHouseDriver',
    Greenplum: 'org.postgresql.Driver',
    IBMDb2: 'com.ibm.db2.jcc.DB2Driver',
    MariaDB: 'org.mariadb.jdbc.Driver',
    MySQL: 'com.mysql.cj.jdbc.Driver',
    Oracle: 'oracle.jdbc.driver.OracleDriver',
    PostgreSQL: 'org.postgresql.Driver',
    Redshift: 'com.amazon.redshift.Driver',
    Snowflake: 'net.snowflake.client.jdbc.SnowflakeDriver',
    SQLServer: 'com.microsoft.sqlserver.jdbc.SQLServerDriver',
    Teradata: 'com.teradata.jdbc.TeraDriver',
    Vertica: 'com.vertica.jdbc.Driver',
}

export const driverPortMapping = {
    BigQuery: '443',
    ClickHouse: '8123',
    Greenplum: '5432',
    IBMDb2: '50000',
    MariaDB: '3306',
    MySQL: '3306',
    Oracle: '1521',
    PostgreSQL: '5432',
    Redshift: '5439',
    Snowflake: '443',
    SQLServer: '1433',
    Teradata: '1025',
    Vertica: '5433',
}
